import { render, staticRenderFns } from "./MaterialityTable.vue?vue&type=template&id=6e9a6953&scoped=true"
import script from "./MaterialityTable.vue?vue&type=script&lang=js"
export * from "./MaterialityTable.vue?vue&type=script&lang=js"
import style0 from "./MaterialityTable.vue?vue&type=style&index=0&id=6e9a6953&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9a6953",
  null
  
)

export default component.exports